import React from 'react';
import { toast } from 'react-toastify';
import classnames from 'classnames';

const config = {
  position: toast.POSITION.BOTTOM_RIGHT,
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

const iconType = (success) => {
  return (
    <div className="ui__toast">
      <i
        className={classnames({
          'icon-ic_thickmark2': success,
          'icon-ic_alert': !success,
        })}
      />
    </div>
  );
};

export const messageSuccess = (message) => {
  toast.success(message, { ...config, icon: iconType(true) });
};

export const messageError = (message) => {
  toast.error(message, { ...config, icon: iconType(false) });
};
